/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Admin_SectionInputs */



/**
* | output |
* | --- |
* | "Admin / Ops" |
*
* @param {Profile_Admin_SectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_admin_section = /** @type {((inputs?: Profile_Admin_SectionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Admin_SectionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Admin / Ops")
	if (locale === "es") return /** @type {LocalizedString} */ ("Admin / Ops")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Admin / Ops")
	if (locale === "it") return /** @type {LocalizedString} */ ("Admin / Ops")
	return /** @type {LocalizedString} */ ("Admin / Ops")
});